// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-indicator[data-v-4653d8f0] {\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #ececec;\n}\n", ""]);
// Exports
module.exports = exports;
